import { jsxs as r, jsx as e } from "react/jsx-runtime";
import I from "react";
import { f as p } from "../../../helpers-CNa1KUVl.mjs";
import { Error as $ } from "../../Error/Error.js";
import { TaskButton as f } from "../../TaskButton/TaskButton.js";
import { FileMode as a } from "../interfaces.js";
import { Wrapper as m, Info as s, FileSizeWrapper as h, Tick as b, ImageWrapper as D, Link as u, UploadDataWrapper as v, BaseWrapper as k, Spinner as C, ButtonsContainer as R, Error as W, ItemWrapper as B } from "./styled.js";
const A = ({
  id: c,
  name: n,
  size: d,
  state: E,
  error: o,
  onRemove: y,
  onCancel: T,
  index: l
}) => {
  let t;
  switch (E) {
    case a.ERROR:
    case a.CANCELLED:
      t = /* @__PURE__ */ r(m, { error: !!o, children: [
        /* @__PURE__ */ r(s, { error: !!o, "data-testid": `file-upload-file-${l}-name`, children: [
          n,
          /* @__PURE__ */ e(h, { children: p(d) }),
          /* @__PURE__ */ e($, { "aria-invalid": !!o, "aria-labelledby": `${n}-label`, children: o ?? null })
        ] }),
        /* @__PURE__ */ e(W, {}),
        /* @__PURE__ */ e(D, { children: /* @__PURE__ */ e(
          u,
          {
            onClick: (i) => {
              i.preventDefault(), y(c);
            },
            children: /* @__PURE__ */ e(
              f,
              {
                iconType: "delete",
                styleType: "normal",
                "data-testid": `file-upload-file-${l}-remove`,
                children: "Remove"
              }
            )
          }
        ) })
      ] });
      break;
    case a.UPLOADING:
      t = /* @__PURE__ */ r(m, { children: [
        /* @__PURE__ */ r(v, { children: [
          /* @__PURE__ */ r(s, { children: [
            /* @__PURE__ */ e(k, { "data-testid": `file-upload-file-${l}-name`, children: n }),
            /* @__PURE__ */ e(h, { children: p(d) })
          ] }),
          /* @__PURE__ */ e(C, {})
        ] }),
        /* @__PURE__ */ e(R, { children: /* @__PURE__ */ e(
          u,
          {
            onClick: (i) => {
              i.preventDefault(), T(c);
            },
            children: /* @__PURE__ */ e(
              f,
              {
                iconType: "cancel",
                styleType: "normal",
                "data-testid": `file-upload-file-${l}-cancel`,
                children: "Cancel"
              }
            )
          }
        ) })
      ] });
      break;
    case a.ADDED:
    case a.FINISHED:
      t = /* @__PURE__ */ r(m, { children: [
        /* @__PURE__ */ r(s, { "data-testid": `file-upload-file-${l}-name`, children: [
          n,
          /* @__PURE__ */ e(h, { children: p(d) })
        ] }),
        /* @__PURE__ */ e(b, {}),
        /* @__PURE__ */ e(D, { children: /* @__PURE__ */ e(
          u,
          {
            onClick: (i) => {
              i.preventDefault(), y(c);
            },
            children: /* @__PURE__ */ e(
              f,
              {
                iconType: "delete",
                styleType: "normal",
                "data-testid": `file-upload-file-${l}-remove`,
                children: "Remove"
              }
            )
          }
        ) })
      ] });
      break;
    case a.ABORTED:
    default:
      t = /* @__PURE__ */ e(k, {});
      break;
  }
  return /* @__PURE__ */ e(B, { children: t });
}, U = I.memo(A);
export {
  U as default
};
